import React, { useEffect, useState, useCallback } from 'react'
import { Card, Grid, Divider, Button } from '@material-ui/core/'
import AccountCircle from '@material-ui/icons/AccountCircle';
import Home from '@material-ui/icons/Home';
import AccountBox from '@material-ui/icons/AccountBox';
import Business from '@material-ui/icons/Business';
import Work from '@material-ui/icons/Work';
import Mail from '@material-ui/icons/Mail';
import Phone from '@material-ui/icons/Phone';
import Sms from '@material-ui/icons/Sms';

import { operators } from '../../../../api/'

import { useParams } from 'react-router-dom'
import { useStoreRehydrated } from '../../../../store'

import SuccessModal from 'components/modal/SuccessModal'
import FailModal from 'components/modal/FailModal'

export default function OrganizationDetails() {
	const { id } = useParams()
	const isRehydrated = useStoreRehydrated()
	const [organizationData, setOrganizationData] = useState({
		companyName: '',
		citizenId: '',
		companyAddress: '',
		reportTypesFixed: '',
		reportTypesMobile: '',
		companyStatus: '',
		email: '',
		telephoneNumber: '',
		mobileNumber: '',
		smsTelephone: '',
		apiToken: '',
		isPayphone: null,
		operatorQOS: [],
	})
	const [tempAPIToken, setTempAPIToken] = useState('')
	const [openEditInfoModal, setOpenEditInfoModal] = useState(false)
	const [openFailModal, setOpenFailModal] = useState(false)
	const [failMessage, setFailMessage] = useState('')
	const [openSuccessModal, setOpenSuccessModal] = useState(false)

	const [validSubmitButton, setValidSubmitButton] = useState(true)
	const [email, setEmail] = useState('')
	const [telephone, setTelephone] = useState('')
	const [smsTelephone, setSmsTelephone] = useState('')
	const [isUseReport1_1_2, setIsUseReport1_1_2] = useState(false)
	const [selectedQOS, setSelectedQOS] = useState([])
	const [allQOSTypes, setAllQOSTypes] = useState([])

	const onOpenSuccessModal = () => {
		setOpenSuccessModal(!openSuccessModal)
	}

	const onOpenFailModal = () => {
		setOpenFailModal(!openFailModal)
	}

	const onChangeEditInfoModal = () => {
		setOpenEditInfoModal(!openEditInfoModal)
	}

	// eslint-disable-next-line
	const onOpenEditInfoModal = () => {
		setEmail(organizationData.email)
		setTelephone(organizationData.mobileNumber)
		setSmsTelephone(organizationData.smsTelephone)
		setIsUseReport1_1_2(organizationData.isUseReport1_1_2)
		setSelectedQOS(organizationData.operatorQOS.map(q => q.qosTypeID))
		onChangeEditInfoModal()
	}

	const onSubmitChangeTeleEmail = async () => {
        const res = await operators.updateOperatorContactInfo(id, telephone, email, smsTelephone, isUseReport1_1_2, selectedQOS)
        onChangeEditInfoModal()
        if (res.status === 200) {
			onOpenSuccessModal()
		} else {
			setFailMessage(res?.data?.message || res?.response?.data?.message || 'เกิดข้อผิดพลาด')
			onOpenFailModal()
		}
        getOrganizationData()
    }

	const onTeleEmailChange = (value, type) => {
		if (type === 'email') {
			setEmail(value)
		} else if (type === 'telephone') {
			setTelephone(value)
		} else if (type === 'smsTelephone') {
			setSmsTelephone(value)
		} else if (type === 'isUseReport1_1_2') {
			setIsUseReport1_1_2(value)
		} else if (type === 'operatorQOS') {
			const currentIndex = selectedQOS.indexOf(value)
			const newChecked = [...selectedQOS]

			if (currentIndex === -1) {
				newChecked.push(value)
			} else {
				newChecked.splice(currentIndex, 1)
			}
			setSelectedQOS(newChecked)
		}
	}

	const getOrganizationData = useCallback(async () => {
		const res = await operators.getOrganizationDataID(id)
		const status = res.status
		const data = res.data
		let reportTypesFixedTemp = ''
		let reportTypesMobileTemp = ''
		if (status === 200) {
			// Logic to select appropriate OperatorInfo (Branch "00000" or first)
			let opInfo = data.operatorInfos;
			if (Array.isArray(opInfo)) {
				opInfo = opInfo.find(i => i.branchNo === '00000') || opInfo[0] || {};
			} else {
				opInfo = {};
			}

			let organizationDataTemp = {
				companyName: data.operatorName,
				citizenId: '1100100010110',
				companyAddress: `${opInfo.addr} ${opInfo.postCode ?? ''}`,
				reportTypesFixed: reportTypesFixedTemp,
				reportTypesMobile: reportTypesMobileTemp,
				companyStatus: 'ดำเนินกิจการอยู่',
				email: opInfo.email,
				telephoneNumber: opInfo.telephone,
				mobileNumber: opInfo.mobile,
				smsTelephone: opInfo.smsTelephone,
				apiToken: data.apiToken,
				isPayphone: data.isPayphone,
				operatorQOS: data.operatorQOS,
				isUseReport1_1_2: data.isUseReport1_1_2,
			}
			setTempAPIToken(data.apiToken)

			setOrganizationData(organizationDataTemp)
		}
	}, [id])

	useEffect(() => {
		const fetchQOSTypes = async () => {
			const res = await operators.getQOSTypes()
			if (res.status === 200) {
				setAllQOSTypes(res.data)
			}
		}
		fetchQOSTypes()
	}, [])

	// const changeAPIToken = async () => {
	// 	const res = await operators.resetAPIToken()
	// 	const status = res.status
	// 	const data = res.data
	// 	if (status === 200) {
	// 		setTempAPIToken(data.token)
	// 		let organizationDataTemp = {
	// 			companyName: organizationData.companyName,
	// 			citizenId: organizationData.citizenId,
	// 			companyAddress: organizationData.companyAddress,
	// 			reportTypesFixed: organizationData.reportTypesFixed,
	// 			reportTypesMobile: organizationData.reportTypesMobile,
	// 			companyStatus: organizationData.companyStatus,
	// 			email: organizationData.email,
	// 			telephoneNumber: organizationData.telephoneNumber,
	// 			mobileNumber: organizationData.mobilephoneNumber,
	// 			apiToken: data.token,
	// 			isPayphone: organizationData.isPayphone,
	// 			operatorQOS: organizationData.operatorQOS,
	// 		}
	// 		setOrganizationData(organizationDataTemp)
	// 	}
	// }

	const validateEmail = (email) => {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return emailRegex.test(email);
	};

	useEffect(() => {
		if (email === '' || telephone === '' || !validateEmail(email) || telephone.length < 9) {
			setValidSubmitButton(true)
		} else {
			setValidSubmitButton(false)
		}
	}, [email, telephone])

	useEffect(() => {
		if (isRehydrated) getOrganizationData()
		// eslint-disable-next-line
	}, [isRehydrated])

	return (
		<>
			<Grid className="p-10 ">
				<Card className={`border-t-4 border-card_top_border`}>
					<Grid className="flex flex-col justify-center items-start px-5">
						<Grid className="flex flex-row mt-4">
							<AccountCircle style={{ fontSize: 22 }} className="mr-1" />
							<Grid className="font-bold text-sm text-card_header_color">
								รายละเอียดผู้ประกอบการ
							</Grid>
						</Grid>
						<Grid className="mt-3 mb-1 w-full">
							<Divider />
						</Grid>
						{/* Company Name */}
						<Grid
							className={`flex flex-row items-center rounded border border-grey-600 h-12 my-2 w-full bg-text_field_bg`}>
							<Grid
								className={`flex flex-row items-center justify-center rounded w-52 h-full px-4 bg-card_top_border`}>
								<AccountBox
									style={{ fontSize: 20 }}
									className="mr-1 h-full text-white"
								/>
								<Grid className="text-white text-sm">ชื่อหน่วยงาน</Grid>
							</Grid>
							<Grid className="pl-4 text-sm flex">
								{organizationData.companyName}
							</Grid>
						</Grid>
						{/* Address */}
						<Grid
							className={`flex flex-row items-center rounded border border-grey-600 h-12 my-2 w-full bg-text_field_bg`}>
							<Grid
								className={`flex flex-row items-center justify-center rounded w-52 h-full px-4 bg-card_top_border`}>
								<Home
									style={{ fontSize: 20 }}
									className="mr-1 h-full text-white"
								/>
								<Grid className="text-white text-sm">ที่อยู่</Grid>
							</Grid>
							<Grid className="pl-4 text-sm flex">
								{organizationData.companyAddress}
							</Grid>
						</Grid>
						{/* Type of Fixed Report */}
						{/* {organizationData.operatorQOS.find(e => e.id === 2) && (
							<Grid
								className={`flex flex-row items-center rounded border border-grey-600 h-12 my-2 w-full bg-text_field_bg`}>
								<Grid
									className={`flex flex-row items-center justify-center rounded w-52 h-full px-4 bg-card_top_border`}>
									<Storage
										style={{ fontSize: 20 }}
										className="mr-1 h-full text-white"
									/>
									<Grid className="text-white text-sm">
										ชุดข้อมูลแบบประจำที่
									</Grid>
								</Grid>
								<Grid className="pl-4 text-sm flex">
									ประเภททั่วไป, ประเภทข้อมูล, ประเภทเสียง
								</Grid>
							</Grid>
						)} */}

						{/* Type of Mobile Report */}
						{/* {organizationData.operatorQOS.find(e => e.id === 1) && (
							<Grid
								className={`flex flex-row items-center rounded border border-grey-600 h-12 my-2 w-full bg-text_field_bg`}>
								<Grid
									className={`flex flex-row items-center justify-center rounded w-52 h-full px-4 bg-card_top_border`}>
									<Storage
										style={{ fontSize: 20 }}
										className="mr-1 h-full text-white"
									/>
									<Grid className="text-white text-sm">
										ชุดข้อมูลแบบเคลื่อนที่
									</Grid>
								</Grid>
								<Grid className="pl-4 text-sm flex">
									ประเภททั่วไป, ประเภทข้อมูล, ประเภทเสียง
								</Grid>
							</Grid>
						)} */}

						{/* Organization Status */}
						<Grid
							className={`flex flex-row items-center rounded border border-grey-600 h-12 my-2 w-full bg-text_field_bg`}>
							<Grid
								className={`flex flex-row items-center justify-center rounded w-52 h-full px-4 bg-card_top_border`}>
								<Work
									style={{ fontSize: 20 }}
									className="mr-1 h-full text-white"
								/>
								<Grid className="text-white text-sm">สถานะการประกอบกิจการ</Grid>
							</Grid>
							<Grid className="pl-4 text-sm flex">
								{organizationData.companyStatus}
							</Grid>
						</Grid>
						{organizationData.isPayphone === 'y' && (
							<Grid
								className={`flex flex-row items-center rounded border border-grey-600 h-12 my-2 w-full bg-text_field_bg`}>
								<Grid
									className={`flex flex-row items-center justify-center rounded w-52 h-full px-4 bg-card_top_border`}>
									<Grid className="text-white text-sm">
										ให้บริการเครื่องโทรศัพท์สาธารณะ
									</Grid>
								</Grid>
								<Grid className="pl-4 text-sm flex">ให้บริการ</Grid>
							</Grid>
						)}

						{/* API Token */}
						<Grid className="flex flex-row items-center justify-between h-full w-full gap-x-4">
							<Grid
								className={`flex flex-row items-center rounded border border-grey-600 h-12 my-2 w-10/12 bg-text_field_bg`}>
								<Grid
									className={`flex flex-row items-center justify-center rounded w-52 h-full px-4 bg-card_top_border`}>
									<Work
										style={{ fontSize: 20 }}
										className="mr-1 h-full text-white"
									/>
									<Grid className="text-white text-sm">API Token</Grid>
								</Grid>
								<Grid className="px-4 text-sm truncate w-96">
									{tempAPIToken}
								</Grid>
							</Grid>
							<Grid
								className={`flex flex-row items-center rounded gap-x-2 h-12 my-2 w-2/12 `}>
								<Button
									variant="outlined"
									color="inherit"
									className="items-center justify-center w-30 h-12 w-full "
									onClick={() => {
										navigator.clipboard.writeText(tempAPIToken)
									}}>
									Copy
								</Button>
								{/* <Button
									variant="outlined"
									color="inherit"
									className="items-center justify-center w-30 h-12"
									onClick={() => {
										changeAPIToken()
									}}>
									Reset
								</Button> */}
							</Grid>
						</Grid>
					</Grid>
				</Card>
			</Grid>
			{/* Organization Status Card */}
			<Grid className="px-10 pb-10">
				<Card className={`border-t-4 border-card_top_border`}>
					<Grid className="flex flex-col justify-center items-start px-5">
						{/* Header */}
						<Grid className="flex flex-row mt-4 items-center justify-between w-full">
							<Grid className="flex flex-row mt-4 items-center justify-between w-full">
								<Grid className="flex flex-row">
									<Business style={{ fontSize: 22 }} className="mr-1" />
									<Grid className="font-bold text-sm text-card_header_color">
										ข้อมูลสำหรับการแจ้งเตือน
									</Grid>
								</Grid>
							</Grid>
						</Grid>
						<Grid className="mt-3 mb-1 w-full">
							<Divider />
						</Grid>

						{/* Notification Settings  */}
						<Grid
							className={`flex flex-row items-center rounded border border-grey-600 h-12 my-2 w-full bg-text_field_bg`}>
							<Grid
								className={`flex flex-row items-center justify-center rounded w-52 h-full px-4 bg-card_top_border`}>
								<Mail
									style={{ fontSize: 20 }}
									className="mr-1 h-full text-white"
								/>
								<Grid className="text-white text-sm">อีเมล</Grid>
							</Grid>
							<Grid className="pl-4 text-sm flex">
								{organizationData.email === null ? '' : organizationData.email}
							</Grid>
						</Grid>
						{/* Phone Num */}
						<Grid
							className={`flex flex-row items-center rounded border border-grey-600 h-12 mt-2 mb-4 w-full bg-text_field_bg`}>
							<Grid
								className={`flex flex-row items-center justify-center rounded w-52 h-full px-4 bg-card_top_border`}>
								<Phone
									style={{ fontSize: 20 }}
									className="mr-1 h-full text-white"
								/>
								<Grid className="text-white text-sm">เบอร์ติดต่อ</Grid>
							</Grid>
							<Grid className="pl-4 text-sm flex">
								{organizationData.mobileNumber}
							</Grid>
						</Grid>
						{/* SMS Phone Num */}
						<Grid
							className={`flex flex-row items-center rounded border border-grey-600 h-12 mt-2 mb-4 w-full bg-text_field_bg`}>
							<Grid
								className={`flex flex-row items-center justify-center rounded w-52 h-full px-4 bg-card_top_border`}>
								<Sms
									style={{ fontSize: 20 }}
									className="mr-1 h-full text-white"
								/>
								<Grid className="text-white text-sm">เบอร์รับการแจ้งเตือน</Grid>
							</Grid>
							<Grid className="pl-4 text-sm flex">
								{organizationData.smsTelephone}
							</Grid>
						</Grid>
					</Grid>
				</Card>
			</Grid>

			<SuccessModal
				title={'การเปลี่ยนแปลงข้อมูลสำเร็จ'}
				open={openSuccessModal}
				handleButton={onOpenSuccessModal}
			/>
			<FailModal
				title={'การเปลี่ยนแปลงข้อมูลไม่สำเร็จ'}
				description={failMessage}
				open={openFailModal}
				handleButton={onOpenFailModal}
			/>
		</>
	)
}
